export function pdfPageUrl(pdfUrl: string, page?: number): string {
  if (!pdfUrl?.trim()) return pdfUrl;
  if (page == null || page < 1) return pdfUrl.split('#')[0];
  return `${pdfUrl.split('#')[0]}#page=${page}`;
}

/** land.gov.il תקנון PDF — approved (`takanonim`) or deposit-stage (`takanonim-h`). */
export function isOfficialTakanonPdfUrl(url: string): boolean {
  return /\/IturTabotData\/takanonim(-h)?\//.test(url.trim());
}
